import { createContext, useMemo, useState } from 'react';

const ReadOnlyContext = createContext({
  isReadOnly: false,
  setIsReadOnly: (_value: boolean) => {},
});

export const ReadOnlyProvider = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => {
  const [isReadOnly, setIsReadOnly] = useState(false);

  const value = useMemo(
    () => ({ isReadOnly, setIsReadOnly }),
    [isReadOnly, setIsReadOnly],
  );

  return (
    <ReadOnlyContext.Provider value={value}>
      {children}
    </ReadOnlyContext.Provider>
  );
};

export { ReadOnlyContext };
